import React from "react";
import { size } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import { Platform } from "@linkfluence/models/platform";
import Icon from "@ui-kit/icon";
import Status from "@radarly/components/cards/card/status";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";
import { getProjectCredentials } from "@radarly/models/project";

interface IProps {
  project: Project;
  locale: Locale;
}

const RadarlyWidgetPictureWallStatus = ({ project, locale }: IProps) => {
  const facebookCredentials = getProjectCredentials(project, Platform.Facebook);
  return (
    <div>
      {size(facebookCredentials) === 0 && (
        <Status
          tooltip={tr(
            locale,
            "CUSTOM_PAGES::TILES::STATUS::CREDENTIAL_MISSING"
          )}
        >
          <Icon glyph="warning" size="m" color="black" />
        </Status>
      )}
    </div>
  );
};

export default RadarlyWidgetPictureWallStatus;
